function FuncFetch( baseUrl, params, method, postObj, instance, accounts){ 
    let stringifiedParams = ''
    if(params){
        let paramsEntries = Object.entries(params)
        paramsEntries.forEach((param,index) => {
            if(index===0){
                stringifiedParams+=`?${param[0]}=${param[1]}`
            }else{
                stringifiedParams+=`&${param[0]}=${param[1]}`
            }
        });
    }

    let activeAccount = instance.getActiveAccount()
    return instance
    .acquireTokenSilent({
        scopes: ["api://0545cd28-732c-4262-9c0e-bdbf335e2b6c/User.Read"],
        account: activeAccount
    })
    .then((response) => {
        const headers = new Headers();
        const bearer = `Bearer ${response.accessToken}`;
    
        headers.append("Authorization", bearer);
        headers.append("Content-Type","application/json")
    
        const options = {
            method: method,
            headers: headers,
        };

        if(postObj){
            options.body = JSON.stringify(postObj)
        }
    
        return fetch((baseUrl+stringifiedParams), options)
        .then(res=>{
            if(res.ok){
                // Check the content type to determine how to parse
                const contentType = res.headers.get("content-type");
                
                if (contentType && contentType.includes("application/json")) {
                    return res.json();
                } else {
                    // If it's not JSON, return as text
                    return res.text().then(text => {
                        // Try to parse as JSON in case content-type header is wrong
                        try {
                            return JSON.parse(text);
                        } catch (e) {
                            // If parsing fails, return the text as is
                            return { message: text, isText: true };
                        }
                    });
                }
            }else{
                console.error(res)
                throw Error(res)
            }
        })
        .then(data=>{
            return data
        })
        .catch(err=>{
            console.error(err)
            throw err
        })
    })
    .catch((error)=>{
        console.error(error)
        throw error
    });
 }

export default FuncFetch;